import {
  FETCH_YADS_STATUS_REQUEST,
  FETCH_YADS_STATUS_SUCCESS,
  FETCH_YADS_STATUS_FAILURE
} from '../../../Constants/actionTypes';

import { fetchYadsPollingStatus } from '../../../Constants/apiService';

export const getYadsStatusRequest = () => ({ type: FETCH_YADS_STATUS_REQUEST });
export const getYadsStatusSuccess = (data) => ({ type: FETCH_YADS_STATUS_SUCCESS, payload: data });
export const getYadsStatusFailure = (error) => ({ type: FETCH_YADS_STATUS_FAILURE, payload: error });

export const getYadsPollingStatus = () => {
  return async (dispatch, getState) => {
    dispatch(getYadsStatusRequest());

    const accessToken = getState().auth.accessToken;

    try {
      const data = await fetchYadsPollingStatus(accessToken);
      console.log("Polling Status Data:", data);
      dispatch(getYadsStatusSuccess(data));
    } catch (error) {
      const errorMsg = error.message?.includes("fetch") ? "Failed to fetch ingestion status." : error.message;
      dispatch(getYadsStatusFailure(errorMsg));
    }
  };
};
